import { Outlet } from 'react-router-dom';

import { BranchSubscriptionExpiredState } from '@/features/auth/components/branch-subscription-expired-state';
import { useIsBranchSubscriptionExpired } from '@/features/auth/hooks/use-is-branch-subscription-expired';
import {
  PageFetchProgressProvider,
  PageFetchProgressSlot,
} from '@/shared/hooks/use-page-fetch-progress';
import { cn } from '@/shared/lib/cn';
import { AdminFooter } from '@/widgets/admin-footer/admin-footer';
import { TopNavigation } from '@/widgets/top-navigation/top-navigation';

export function AdminLayout() {
  const isBranchSubscriptionExpired = useIsBranchSubscriptionExpired();

  return (
    <PageFetchProgressProvider>
      <div className="fixed inset-0 flex flex-col overflow-hidden overscroll-none bg-content-bg">
        <TopNavigation />
        <PageFetchProgressSlot />
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
          <div className="flex min-h-full flex-col">
            <main
              className={cn(
                'mx-auto w-full flex-1 px-4 py-6 sm:px-8 md:px-12',
                isBranchSubscriptionExpired && 'flex flex-col',
              )}
            >
              {isBranchSubscriptionExpired ? (
                <BranchSubscriptionExpiredState />
              ) : (
                <Outlet />
              )}
            </main>
            <AdminFooter />
          </div>
        </div>
      </div>
    </PageFetchProgressProvider>
  );
}
